export default "__VITE_ASSET__CjaHFTIv__"